// src/app/core/guards/nfc-auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/api/auth.service';
import { NfcService } from '../services/api/nfc.service';

/**
 * 🔐 Guard funcional que valida NFC antes de navegar
 * Solo aplica para usuarios con roles que requieren NFC
 */
export const nfcAuthGuard: CanActivateFn = (route, state): Observable<boolean> => {
    const authService = inject(AuthService);
    const nfcService = inject(NfcService);
    const router = inject(Router);

    // Si no está autenticado, redirige al login
    if (!authService.isAuthenticated()) {
        router.navigate(['/auth/login']);
        return of(false);
    }

    // Si el usuario NO requiere NFC, permite el acceso
    if (!authService.requiresNfc()) {
        console.log('✅ Usuario no requiere NFC, acceso permitido');
        return of(true);
    }

    console.log('🔍 Verificando tarjeta NFC...');

    // Si requiere NFC, verifica la tarjeta
    return nfcService.verifyCurrentCard().pipe(
        map((isValid) => {
            if (!isValid) {
                console.error('❌ Tarjeta NFC no válida o no presente');
                authService.logout();
                router.navigate(['/auth/login'], {
                    queryParams: { error: 'nfc_required', message: 'Credencial NFC no detectado' }
                });
                return false;
            }
            console.log('✅ Tarjeta NFC válida');
            return true;
        }),
        catchError((error) => {
            console.error('❌ Error en NFC Guard:', error);
            authService.logout();
            router.navigate(['/auth/login'], {
                queryParams: { error: 'nfc_error', message: 'Error al leer la tarjeta NFC' }
            });
            return of(false);
        })
    );
};
